import { render, staticRenderFns } from "./commend.vue?vue&type=template&id=435892c6&"
import script from "./commend.vue?vue&type=script&lang=js&"
export * from "./commend.vue?vue&type=script&lang=js&"
import style0 from "./commend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports